import React, { FC, ReactElement } from 'react'
import dynamic from 'next/dynamic'

const PasswordModalController = dynamic(
	() => import('@/components/controllers/password-modal-controller')
)

const SignoutModalController = dynamic(
	() => import('@/components/controllers/signout-modal-controller')
)

const SnackbarController = dynamic(() => import('@/components/controllers/snackbar-controller'))
const ApiContextController = dynamic(
	() => import('@/components/controllers/api-context-controller')
)
const RelistAfterSplitController = dynamic(
	() => import('@/components/controllers/relist-after-split-controller')
)
const PageTrackerController = dynamic(
	() => import('@/components/controllers/page-tracker-controller')
)
const FreezeWatchController = dynamic(
	() => import('@/components/controllers/freeze-watch-controller')
)

const _WalletWarningController = dynamic(
	() => import('@/components/controllers/wallet-warning-modal-controller')
)

const BroadcastModalController = dynamic(
	() => import('@/components/controllers/broadcast-modal-controller')
)

const ListItemModalController = dynamic(
	() => import('@/components/controllers/list-item-modal-controller')
)

const PurchaseModalController = dynamic(
	() => import('@/components/controllers/purchase-modal-controller')
)

const InscriptionDetailModalController = dynamic(
	() => import('@/components/controllers/inscription-detail-modal-controller')
)

const InsufficientFundsModalController = dynamic(
	() => import('@/components/controllers/insufficient-funds-modal-controller')
)

const PwaLaunchController = dynamic(() => import('@/components/controllers/pwa-launch-controller'))

const MoonpayModalController = dynamic(
	() => import('@/components/controllers/moonpay-modal-controller')
)

const _FloatingMenuController = dynamic(
	() => import('@/components/controllers/floating-menu-controller')
)

const GetNotificationsController = dynamic(
	() => import('@/components/controllers/get-notifications-modal-controller')
)

const UnisatController = dynamic(() => import('@/components/controllers/unisat-controller'))
const InscribeController = dynamic(() => import('@/components/controllers/inscribe-controller'))

const IncomingOffersController = dynamic(() => import('@/components/offers/incoming-offers-controller'))

const Controllers: FC = (): ReactElement => {
	return (
		<>
			<InscribeController />
			<IncomingOffersController />
			<UnisatController />
			<PasswordModalController />
			<SignoutModalController />
			<SnackbarController />
			<ApiContextController />
			<RelistAfterSplitController />
			<PageTrackerController />
			<FreezeWatchController />
			{/* <WalletWarningController /> */}
			<GetNotificationsController />
			<BroadcastModalController />
			<ListItemModalController />
			<PurchaseModalController />
			<InscriptionDetailModalController />
			<InsufficientFundsModalController />
			<MoonpayModalController />
			<PwaLaunchController />
			{/* <FloatingMenuController /> */}
		</>
	)
}

export default Controllers
